import React, { useEffect, useState } from "react";
import { api, fmtINR } from "@/lib/api";
import { Package, ShoppingBag, IndianRupee } from "lucide-react";

export default function AdminOverview() {
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/products"), api.get("/admin/orders")]).then(([p, o]) => {
      setProducts(p.data); setOrders(o.data);
    }).catch(() => {});
  }, []);

  const revenue = orders.filter((o) => o.status === "paid").reduce((s, o) => s + o.total_inr, 0);
  const stats = [
    { label: "Products", value: products.length, icon: Package },
    { label: "Orders", value: orders.length, icon: ShoppingBag },
    { label: "Revenue (paid)", value: fmtINR(revenue), icon: IndianRupee },
  ];

  return (
    <div data-testid="admin-overview">
      <h1 className="font-display text-3xl tracking-tight mb-6">Overview</h1>
      <div className="grid gap-px sm:grid-cols-3 bg-white/10 border border-white/10 mb-8">
        {stats.map((s) => (
          <div key={s.label} className="bg-zinc-950 p-5">
            <div className="flex items-center gap-2 text-white/50 mono-label"><s.icon className="h-4 w-4"/>{s.label}</div>
            <div className="font-mono text-2xl mt-2">{s.value}</div>
          </div>
        ))}
      </div>

      <p className="mono-label text-white/50 mb-3">Recent orders</p>
      <div className="border border-white/10 bg-zinc-950 divide-y divide-white/10">
        {orders.slice(0, 8).map((o) => (
          <div key={o.id} className="p-4 flex justify-between items-center text-sm">
            <div>
              <p className="font-mono text-xs text-white/50">#{o.id.slice(0, 8)}</p>
              <p>{o.items.length} items · {new Date(o.created_at).toLocaleString("en-IN")}</p>
            </div>
            <div className="text-right">
              <span className="mono-label text-white/60">{o.status}</span>
              <p className="font-mono">{fmtINR(o.total_inr)}</p>
            </div>
          </div>
        ))}
        {orders.length === 0 && <div className="p-6 text-center text-white/50 text-sm">No orders yet.</div>}
      </div>
    </div>
  );
}
